import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import Routes from "./Routes";
import { Auth } from "aws-amplify";
import "./App.css";
import Footer from "./components/Footer"

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isAuthenticated: false,
      isAuthenticating: true,
      user: {}
    };
  }

  async componentDidMount() {
    try {
      if (await Auth.currentSession()) {
        this.userHasAuthenticated(true);
        this.setAuthenticatedUser();
      }
    }
    catch(e) {
      if (e !== 'No current user') {
        alert(e);
      }
    }

    this.setState({ isAuthenticating: false });
  }

  userHasAuthenticated = authenticated => {
    this.setState({ isAuthenticated: authenticated });
    this.setAuthenticatedUser();
  }

  setAuthenticatedUser = async () => {
    var user = await Auth.currentAuthenticatedUser();
    this.setState({ user: user });
  }

  handleLogout = async event => {
    await Auth.signOut();

    this.userHasAuthenticated(false);

    this.props.history.push("/login");
  }

  render() {

    const childProps = {
      isAuthenticated: this.state.isAuthenticated,
      userHasAuthenticated: this.userHasAuthenticated,
      user: this.state.user
    };

    return (
      !this.state.isAuthenticating &&
      <div>
        <div className="App container">
          <Navbar fluid collapseOnSelect>
            <Navbar.Header>
              <Navbar.Brand>
                <Link to="/">My Cloud Line</Link>
              </Navbar.Brand>
              <Navbar.Toggle />
            </Navbar.Header>
            <Navbar.Collapse>
              {this.state.isAuthenticated && this.state.user !== {}
                ? <Nav>
                    <LinkContainer to={"/timeline/" + this.state.user.username}>
                      <NavItem>Your Timeline</NavItem>
                    </LinkContainer>
                  </Nav>
                : <Nav></Nav>
              }
              <Nav pullRight>
                <LinkContainer to="/about">
                  <NavItem>About</NavItem>
                </LinkContainer>
                {this.state.isAuthenticated
                  ? <NavItem onClick={this.handleLogout}>Logout</NavItem>
                  : <Fragment>
                      <LinkContainer to="/signup">
                        <NavItem>Signup</NavItem>
                      </LinkContainer>
                      <LinkContainer to="/login">
                        <NavItem>Login</NavItem>
                      </LinkContainer>
                    </Fragment>
                }
              </Nav>
            </Navbar.Collapse>
          </Navbar>
          <Routes childProps={childProps} />
          <Footer>
            <div>
              {this.state.isAuthenticated
                ? <div></div>
                : <h4><a href="/signup">Signup</a> for a free account to create your own timeline</h4>
              }
              <address>
                <h4>Need support? Contact the creator at <b>kyle.l.mera@gmail.com</b></h4>
              </address>
            </div>
          </Footer>
        </div>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js